import { ReactElement } from 'react';
import AppRoutes from '@app/AppRoutes';
import ThemeProvider from '@common/theme/ThemeProvider';

const App = (): ReactElement => {
  return (
    <ThemeProvider>
      <AppRoutes />
    </ThemeProvider>
  );
};

export default App;
